var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lots && _vm.lots.length > 0
    ? _c(
        "div",
        { staticClass: "sync-scroll-bars" },
        [
          _c(
            "el-table",
            {
              key: "TotalGeneral_" + _vm.refresh,
              attrs: {
                data: [{}],
                size: "mini",
                "row-class-name": "total",
                "data-sync-scrollbar": "summaries"
              }
            },
            [
              _c("el-table-column", { attrs: { width: "40", fixed: "left" } }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { width: "250", fixed: "left" } }),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { width: "150", fixed: "left", align: "right" } },
                [_vm._v("TOTAL GENERAL")]
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                { attrs: { "class-name": "separator", width: "15" } },
                [_vm._v(" ")]
              ),
              _vm._v(" "),
              _vm._l(_vm.nbCol, function(col) {
                return _c(
                  "el-table-column",
                  { key: col, attrs: { width: "120", align: "right" } },
                  [
                    _c("template", { slot: "header" }, [
                      _vm._v(
                        "\n        Aléas n°" +
                          _vm._s(col) +
                          " " +
                          _vm._s(_vm._f("toDate")(_vm.dateCol(col))) +
                          "\n      "
                      )
                    ]),
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm._f("toCurrency")(
                            _vm.calculs.affaire.mtTotalGeneralColonneProvision[
                              col
                            ]
                          )
                        ) +
                        "\n    "
                    )
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _vm.modeEdit
                ? _c(
                    "el-table-column",
                    {
                      attrs: {
                        label: "Transfert n° " + (_vm.nbCol + 1),
                        width: "120",
                        align: "right"
                      }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm._f("toCurrency")(
                              _vm.calculs.affaire
                                .mtTotalGeneralColonneProvision[_vm.nbCol + 1]
                            )
                          ) +
                          "\n    "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: { label: "Total Aléas", width: "120", align: "right" }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm._f("toCurrency")(
                          _vm.calculs.affaire.mtTotalGeneralLigneProvision
                        )
                      ) +
                      "\n    "
                  )
                ]
              )
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }